export function getResetDiscountDialogId(
    hasOfferManufacturerDiscount: boolean, 
    hasPositionManufacturerDiscounts: boolean): string | undefined {
    if (hasOfferManufacturerDiscount && hasPositionManufacturerDiscounts) {
      return "RESET_POSITION_AND_OFFER_DISCOUNT";
    } else if (hasOfferManufacturerDiscount) {
      return "RESET_OFFER_DISCOUNT";
    } else if (hasPositionManufacturerDiscounts) {
      return "RESET_POSITION_DISCOUNT";
    }
  }